import { createRecipe } from './runtime.mjs';

const dividerWithLabelConfig = {"name":"dividerWithLabel","className":"ds-divider-with-label"}

export const dividerWithLabel = /* @__PURE__ */ createRecipe(dividerWithLabelConfig)